export const pagesJson={
    "home":"Home",
    "my-enquiry":"Enquiry",
    "form":"Add Product",
    "products":"Add Product",
    "bulk-upload":"Bulk Upload",
    "add-Product":"Choose from Catalogue",
    "drafted":"Draft",
    "profile":"Profile",
    "graborder":"My Order",
    "unprocessed":"My Order",
    "processed":"My Order",
    "cancelled":"My Order",
    "redispatch":"My Order",
    "inTransit":"My Order",
    "revoke":"My Order",
    "delivered":"My Order",
    "allOrders":"My Order",
    "allOrders":"My Order",
    "in_transit":"My Order",
    "active":"My Products",
    "actionrequired":"My Products",
    "weightverification":"My Products",
    "support":"Customer Support",
    "my-transactions":"Reports",
    "order-summary":"Reports",
    "approv":"Product Details",
    "monthly_report":"Reports",
    "completed":"Payments",
    "deduction":"Payments",
    "onhold":"Payments",
    "penalty":"Payments",
    "my-brands":"My Brands",
    "faq-tcs":"FAQ",
    "faq-tds":"FAQ",
    "faq-form16":"FAQ",
    "answered":"Questions & Answer",
    "pending":"Questions & Answer",
    "ignored":"Questions & Answer",
    "details":"Lead Management",
    "vendor-transaction":"Transaction Details",
    "tv-transaction":"Transaction Details",
    "outofstock":"Out of Stock Products",
    "customerReviews":"Customer Reviews",
    // "new-opportunities":"New Opportunities",
    "all-opportunities":"Availed Opportunities",
    // "pricing-opportunities":"Pricing Opportunities",
    // "outofstock-opportunities":"Out of Stock Opportunities",
    "quarterly_report":"Reports",
    }